"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PostItCard", {
  enumerable: true,
  get: function get() {
    return _PostItCard["default"];
  }
});
var _PostItCard = _interopRequireDefault(require("./PostItCard"));